// Shared helpers to build public URLs and normalize profile images

export const buildPublicUrl = (bucket, path) => {
  if (!path) return null;
  const trimmed = path.replace(/^https?:\/\/[^/]+\/storage\/v1\/object\/public\//, '');
  if (trimmed.startsWith('http')) return trimmed;
  const clean = trimmed.replace(/^\/+/, '');
  const base = process.env.REACT_APP_SUPABASE_URL;
  return `${base}/storage/v1/object/public/${bucket}/${clean}`;
};

export const normalizeProfileImage = (img) => {
  if (!img) return null;
  if (img.startsWith('http')) return img;
  const clean = img.startsWith('profiles/') ? img : `profiles/${img}`;
  return buildPublicUrl('profile-images', clean);
};

